import Vue from 'vue'
import { PageHeader, Button } from 'ant-design-vue'

import './css/index.less'

Vue.use(PageHeader)
Vue.use(Button)
